import { render } from "./Main.vue?vue&type=template&id=33c8e3bc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=33c8e3bc&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c8e3bc"]])

export default __exports__